import type { HealthCheckResponse } from '@graphit/types'
import axios from 'axios'

import env from '../environments'

export async function healthcheck() {
	const response = await axios.get(env.apiUrl)

	return response.data as HealthCheckResponse
}

export async function ping() {
	return axios.get(env.apiUrl + '/ping')
}
